import { render, staticRenderFns } from "./DeliveryDay.vue?vue&type=template&id=f87d88a8&scoped=true&"
import script from "./DeliveryDay.vue?vue&type=script&lang=js&"
export * from "./DeliveryDay.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDay.vue?vue&type=style&index=0&id=f87d88a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87d88a8",
  null
  
)

export default component.exports